// extracted by mini-css-extract-plugin
export default {"title":"index_title_mlm3T","list":"index_list_0PD4C"};